/* eslint-disable eqeqeq */
// @ts-nocheck
import { configure, makeAutoObservable } from "mobx";
import { apiClient } from "../base-classes/apiBaseClass";
import notificationState from "./notification-state";
import auth from "./auth-state";

/** Collect human-readable messages from API failure payloads (message, errors array/string, nested). */
function collectApiFailureMessages(payload) {
    const out = [];
    const push = (s) => {
        if (typeof s === "string" && s.trim()) out.push(s.trim());
    };
    if (!payload || typeof payload !== "object") return out;
    const { errors, message } = payload;
    if (Array.isArray(errors)) {
        errors.forEach((item) => {
            if (typeof item === "string") push(item);
            else if (item && typeof item === "object" && item.message != null) push(String(item.message));
        });
    } else if (typeof errors === "string") {
        push(errors);
    }
    push(message);
    return [...new Set(out)];
}

function notifyApiFailure(payload) {
    const msgs = collectApiFailureMessages(payload);
    if (msgs.length === 0) {
        notificationState.addToasterError("Something went wrong, try again...");
    } else {
        msgs.forEach((m) => notificationState.addToasterError(m));
    }
}

export interface IUser {
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    activationToken: string;
    emailVerifiedAt: string | null;
    lastLogin: string | null;
    createdAt?: string;
    updatedAt?: string;
    deleted?: boolean;
    status?: string;
    UserStateToken: string;
    role: string;
}


class UserState {
    private _userList?: IUser[] | null | undefined;

    constructor() {
        configure({ enforceActions: "never" });
        makeAutoObservable(this);
    }

    async getAdminStats(dates = {}) {
        try {
            let params = '';
            if (dates.startDate && dates.endDate) {
                params = `startDate=${dates.startDate}&endDate=${dates.endDate}`
            }
            const response = await apiClient.get("admin/admin-dashboard-stats?" + params);
            console.log(response.data);
            return response.data;
        } catch (e: any) {
            notificationState.addToasterError(this.errorMsg || 'Something went wrong, try again...');
        }
    }
    async getUserStats(dates = {}) {
        try {
            let params = '';
            if (dates.startDate && dates.endDate) {
                params = `startDate=${dates.startDate}&endDate=${dates.endDate}`
            }
            const response = await apiClient.get("user-dashboard-stats?" + params);
            return response.data;
        } catch (e: any) {
            notificationState.addToasterError(this.errorMsg || 'Something went wrong, try again...');
        }
    }
    async getuserList(config) {
        try {
            const response = await apiClient.get(`admin/users?per_page=${config.per_page || 10}&page=${config.page}&order_by=${config.order_by || 'desc'}&order_by_field=${config.order_by_field || 'createdAt'}&search=${config.search || ''}`);
            return response.data;
        } catch (e: any) {
            notificationState.addToasterError(this.errorMsg || 'Something went wrong, try again...');
        }
    }
    async getManualUserList(config) {
        try {
            const response = await apiClient.get(`admin/manual-users?per_page=${config.per_page || 10}&page=${config.page}&order_by=${config.order_by || 'desc'}&order_by_field=${config.order_by_field || 'createdAt'}&search=${config.search || ''}`);
            return response.data;
        } catch (e: any) {
            notificationState.addToasterError(this.errorMsg || 'Something went wrong, try again...');
        }
    }
    async getcontactList(config) {
        try {
            const response = await apiClient.get(`admin/admin-contact-us-list?per_page=${config.per_page || 10}&page=${config.page}&order_by=${config.order_by || 'desc'}&order_by_field=${config.order_by_field || 'createdAt'}&search=${config.search || ''}`);
            return response.data;
        } catch (e: any) {
            notificationState.addToasterError(this.errorMsg || 'Something went wrong, try again...');
        }
    }
    async toggleUserStatus(user: any) {
        try {
            user.loading = true;
            const status = user.status === "Active"
                ? "InActive" : "Active";
            const response = await apiClient.post(`admin/update-user-status`, { id: user.id, status });
            user.status = status;
            notificationState.addToasterSuccess(response.message || 'API Key status successfully!');

        } catch (error) {
            this.handleError(error);
        }
        user.loading = false;
    }
    async contactUsReply(email: any, full_name: any, message: any, contactId: any) {
        try {

            const response = await apiClient.post(`admin/contact-us-reply`, { 
                email: email, 
                full_name: full_name, 
                message: message,
                contact_id: contactId 
            });
            notificationState.addToasterSuccess(response.message || 'Reply successfully send!');
            return response; // Return the response so the modal can check the status

        } catch (error) {
            this.handleError(error);
            throw error; // Re-throw error so modal can handle it
        }
    }


    async updateProfile(data) {
        try {
            const endPoint = auth.isAdmin ? `admin/profile-update` : `update-user`;
            const response = await apiClient.post(endPoint, {
                firstName: data.firstName,
                lastName: data.lastName,
                profileImage: data.profileImage,
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response.status) {
                auth.currentUser.firstName = data.firstName;
                auth.currentUser.lastName = data.lastName;
                auth.currentUser.profileImage = response.data?.user?.profileImage || response.data?.admin?.profileImage || auth.currentUser.profileImage;
                auth.synchronizeUserState();
                notificationState.addToasterSuccess(response.message || 'Profile updated successfully...');
            } else {
                notifyApiFailure(response);
            }

        } catch (error) {
            this.handleError(error);
        }
    }

    async changePassword(data) {
        let status = false;
        try {
            const endPoint = auth.isAdmin ? `admin/change-password` : `change-password`;
            const response = await apiClient.post(endPoint, {
                old_password: data.currentPassword,
                new_password: data.newPassword,
            });
            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'Password changed successfully...');
            } else {
                response.errors?.forEach(m => {
                    notificationState.addToasterError(m);
                });
            }
            status = response.status;;
        } catch (error) {
            this.handleError(error);
        }
        return status;
    }

    async updateUser(data) {
        try {
            const payload: any = {
                firstName: data.firstName,
                lastName: data.lastName,
                id: data.id
            };
            if (data.pdf_limit !== undefined && data.pdf_limit !== null && `${data.pdf_limit}` !== '') {
                payload.pdf_limit = Number(data.pdf_limit);
            }
            const response = await apiClient.post(`admin/update-user`, payload);
            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'User update successfully...');
                return true
            } else {
                response.errors?.forEach(m => {
                    notificationState.addToasterError(m);
                });
            }

        } catch (error) {
            this.handleError(error);
        }
        return false
    }

    async createUser(data, mode: "default" | "manual" = "default") {
        try {
            const endpoint = mode === "manual" ? `admin/manual-create-user` : `admin/create-user`;
            const response = await apiClient.post(endpoint, {
                firstName: data.firstName,
                lastName: data.lastName,
                email: data.email,
                password: data.password
            });

            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'User added successfully...');
                return response;
            } else {
                response.errors?.forEach(m => {
                    notificationState.addToasterError(m);
                });
            }
        } catch (error) {
            this.handleError(error);
        }
        return null;
    }

    async assignManualSubscription(userId: number | string, planId: string, pdfLimit?: number) {
        try {
            const response = await apiClient.post(`admin/manual-update-subscription`, {
                user_id: Number(userId),
                plan_id: planId,
                pdf_limit: pdfLimit,
            });
            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'Subscription updated successfully...');
                return true;
            }
            response.errors?.forEach(m => notificationState.addToasterError(m));
        } catch (error) {
            this.handleError(error);
        }
        return false;
    }

    async cancelManualSubscription(userId: number | string) {
        try {
            const response = await apiClient.post(`admin/manual-cancel-subscription`, {
                user_id: Number(userId),
            });
            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'Subscription cancelled successfully...');
                return true;
            }
            response.errors?.forEach(m => notificationState.addToasterError(m));
        } catch (error) {
            this.handleError(error);
        }
        return false;
    }

    async deleteUser(id) {
        try {
            const response = await apiClient.post(`admin/delete-user`, { id });
            notificationState.addToasterSuccess(response.message || 'User has been deleted successfully...');
        } catch (error) {
            this.handleError(error);
        }
    }
    async verifyUser(user: any) {
        try {
            user.loading = true;
            const response = await apiClient.post(`admin/verify-user`, { id: user.id });
            notificationState.addToasterSuccess(response.message || 'User verified and activated successfully!');
            return response.status;
        } catch (error) {
            this.handleError(error);
            return false;
        } finally {
            user.loading = false;
        }
    }
    async deleteContact(id) {
        try {
            const response = await apiClient.post(`admin/admin-contact-us-msg-delete`, { id });
            notificationState.addToasterSuccess(response.message || 'Contact Inquiries has been deleted successfully...');
        } catch (error) {
            this.handleError(error);
        }
    }

    async getSingleUserDetail(id) {
        try {
            const response = await apiClient.get(`/admin/users/${id}`);
            return response?.data?.user;
        } catch (error) {
            this.handleError(error);
        }
    }

    handleError(error) {
        if (error?.response?.status === 401) {
            return;
        }
        const data = error?.response?.data;
        if (data && typeof data === "object") {
            notifyApiFailure(data);
            return;
        }
        const e = error?.message || "Something went wrong, try again...";
        notificationState.addToasterError(e);
    }

    async subscribeToNewsLetter(data) {
        try {
            const response = await apiClient.post(`newsletter`, { ...data });
            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'Subscription successful! Thank you for subscribing.');
            } else {
                notificationState.addToasterError(response.message || 'Subscription failed. Please try again.');
            }

            return response.status;
        } catch (error) {
            this.handleError(error);
        }
    }

    
    async contactUs(form) {
        try {
            const response = await apiClient.post(`contact-us`, { ...form });
            if (response.status) {
                notificationState.addToasterSuccess(response.message || 'User has been deleted successfully...');
            } else {
                notificationState.addToasterError(response.message || 'Something went wrong, try again...');
            }

            return response.status
        } catch (error) {
            this.handleError(error);
        }
    }
}

const userState = new UserState();

export default userState;
